import { create } from "zustand";
export const useInjectiveStore = create(() => ({
    walletStrategy: undefined,
}));
